// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4de53380","239":"e673281d","453":"5bd33cc4","455":"a2b8bcf9"}[chunkId] + ".chunk.js";
};